<template>
  <HeaderDashboardCards
    data-testid="departments-header-dashboard"
    aria-label="Departments summary"
    :metrics="cards"
    variant="count-only"
    :action-label="actionLabel"
    @select="handleSelect"
  />
</template>

<script setup>
import { computed } from "vue";
import HeaderDashboardCards from "@components/HeaderDashboardCards/HeaderDashboardCards.vue";

const props = defineProps({
  activeCount: {
    type: Number,
    default: 0,
  },
  draftCount: {
    type: Number,
    default: 0,
  },
  orphanPositionsCount: {
    type: Number,
    default: 0,
  },
  notManagedCount: {
    type: Number,
    default: 0,
  },
  /**
   * Key of the card whose filter combination is currently applied
   * ('active' | 'draft' | 'not-managed'). Pressed state only; clicking the
   * active card again resets to the default filter state.
   */
  activeIndicator: {
    type: String,
    default: null,
    validator: (v) => v === null || ["active", "draft", "not-managed"].includes(v),
  },
  /** Verb used only in each clickable card's accessible name. */
  actionLabel: {
    type: String,
    default: "Apply Filter",
  },
});

const emit = defineEmits(["select-indicator"]);

const cards = computed(() => [
  {
    key: "active",
    title: "Active Departments",
    count: props.activeCount,
    clickable: true,
    active: props.activeIndicator === "active",
    alert: false,
  },
  {
    key: "draft",
    title: "Draft Departments",
    count: props.draftCount,
    clickable: true,
    active: props.activeIndicator === "draft",
    alert: false,
  },
  {
    key: "orphan-positions",
    title: "Unassigned Positions",
    count: props.orphanPositionsCount,
    alert: true,
  },
  {
    key: "not-managed",
    title: "Not Managed",
    count: props.notManagedCount,
    clickable: true,
    active: props.activeIndicator === "not-managed",
    alert: true,
  },
]);

function handleSelect(key) {
  emit("select-indicator", key);
}
</script>
